import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import Form from "@rjsf/chakra-ui";
import { RJSFSchema, UiSchema } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
import { useState } from "react";

import { useCreateUser } from "../api/create-user";

const schema: RJSFSchema = {
  title: "Nieuwe gebruiker",
  type: "object",
  required: ["email"],
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "E-mailadres",
    },
    writeAccess: {
      type: "boolean",
      title: "Schrijftoegang",
      default: false,
    },
  },
};

const uiSchema: UiSchema = {
  email: {
    "ui:placeholder": "Voer e-mailadres in",
  },
  writeAccess: {
    "ui:widget": "checkbox",
    "ui:title": "Gebruiker kan rapportage's aanmaken",
  },
  "ui:title": "",
};

export function UserCreateModal() {
  const [isCreating, setIsCreating] = useState(false);
  const { mutate, isPending } = useCreateUser();
  const onClose = () => setIsCreating(false);
  return (
    <>
      <Button
        onClick={() => setIsCreating(true)}
        variant="secondary"
        leftIcon={<AddIcon m={0} h={4} w={4} />}
      >
        Gebruiker toevoegen
      </Button>
      <Modal isCentered isOpen={isCreating} onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nieuwe gebruiker toevoegen</ModalHeader>
          <ModalCloseButton />
          <ModalBody px={6}>
            <Form
              schema={schema}
              uiSchema={uiSchema}
              validator={validator}
              onSubmit={({ formData }) => {
                mutate(formData);
                onClose();
              }}
            >
              {/* Form fields will be rendered here automatically */}
              <Flex py={4} justifyContent="flex-end" gap={4}>
                <Button variant="secondary" onClick={onClose}>
                  Annuleren
                </Button>
                <Button type="submit" variant="primary" isLoading={isPending}>
                  Gebruiker toevoegen
                </Button>
              </Flex>
            </Form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
